import axios from 'axios';
import { React, useState } from 'react';
import { Link } from 'react-router-dom';
import { useStateContext } from './Context/ContextProvider';
import Swal from "sweetalert2";
import Puff from 'react-loading-icons/dist/esm/components/puff';

function Login() {
  const [isClick, setIsClick] = useState(false);
  const { setUser, setToken, setType, setUserId } = useStateContext();
  const [Login, setLogin] = useState({
    email: '',
    password: '',
    errorlist: {}
  });
  const [fieldErrors, setFieldErrors] = useState({});

  const handleInput = (e) => {
    e.persist();
    setLogin({ ...Login, [e.target.name]: e.target.value });
    // Clear field error when user starts typing
    if (fieldErrors[e.target.name]) {
      setFieldErrors(prev => ({ ...prev, [e.target.name]: '' }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!Login.email.trim()) {
      setFieldErrors(prev => ({ ...prev, email: 'Email is required' }));
      return;
    }
    if (!Login.password) {
      setFieldErrors(prev => ({ ...prev, password: 'Password is required' }));
      return;
    }

    setIsClick(true);
    const data = {
      email: Login.email,
      password: Login.password
    };

    axios.get('/sanctum/csrf-cookie')
      .then(response => {
        axios.post('/api/login', data)
          .then(res => {
            if (res.data.status === 200) {
              setUser(res.data.username);
              setToken(res.data.token);
              setType(res.data.type);
              setUserId(res.data.id);
            } else if (res.data.status === 401) {
              Swal.fire({
                icon: 'warning',
                title: 'Login Failed',
                text: res.data.message,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Try Again'
              });
              setFieldErrors({});
            } else if (res.data.validation_errors) {
              setFieldErrors(res.data.validation_errors);
            } else if (res.data.message) {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: res.data.message,
                confirmButtonColor: '#3085d6'
              });
            }
            setIsClick(false);
          })
          .catch(error => {
            console.error('Login error:', error);
            Swal.fire({
              icon: 'error',
              title: 'Connection Error',
              text: 'Unable to connect to server. Please check your connection.',
              confirmButtonColor: '#3085d6'
            });
            setIsClick(false);
          });
      })
      .catch(error => {
        console.error('CSRF error:', error);
        Swal.fire({
          icon: 'error',
          title: 'Connection Error',
          text: 'Unable to initialize secure connection.',
          confirmButtonColor: '#3085d6'
        });
        setIsClick(false);
      });
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-wrapper">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9L12 3L21 9L12 15L3 9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M5 15V19L12 23L19 19V15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M21 9V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 15V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h1 className="login-title">NETROX POS</h1>
          
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <label htmlFor="email">Email Address</label>
            <div className="input-wrapper">
              <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <input
                id="email"
                type="email"
                name="email"
                value={Login.email}
                onChange={handleInput}
                placeholder="admin@example.com"
                className={fieldErrors.email ? 'error' : ''}
              />
            </div>
            {fieldErrors.email && <span className="error-message">{fieldErrors.email}</span>}
          </div>

          <div className="input-group">
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 3C9.79 3 8 4.79 8 7V10H6C4.9 10 4 10.9 4 12V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V12C20 10.9 19.1 10 18 10H16V7C16 4.79 14.21 3 12 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 16C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <input
                id="password"
                type="password"
                name="password"
                value={Login.password}
                onChange={handleInput}
                placeholder="Enter your password"
                className={fieldErrors.password ? 'error' : ''}
              />
            </div>
            {fieldErrors.password && <span className="error-message">{fieldErrors.password}</span>}
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={isClick}
          >
            {isClick ? (
              <>
                <Puff width={22} height={22} className="button-spinner" />
                <span>Signing in...</span>
              </>
            ) : (
              <span>Sign In</span>
            )}
          </button>

          <p className="signup-link" style={{ display: 'none' }}>
            Don't have an account? <Link to="/signup">Create an account</Link>
          </p>
        </form>
      </div>

      <style jsx>{`
        .login-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(145deg, #0f2027 0%, #203a43 50%, #2c5364 100%);
          padding: 20px;
        }

        .login-card {
          background: white;
          border-radius: 24px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          width: 100%;
          max-width: 440px;
          padding: 40px 32px;
          transition: transform 0.2s ease;
        }

        .login-card:hover {
          transform: translateY(-5px);
        }

        .login-header {
          text-align: center;
          margin-bottom: 36px;
        }

        .logo-wrapper {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 64px;
          height: 64px;
          background: linear-gradient(145deg, #0f2027 0%, #203a43 50%, #2c5364 100%);
          border-radius: 20px;
          margin-bottom: 20px;
          color: white;
        }

        .login-title {
          font-size: 28px;
          font-weight: 700;
          color: #1a1a2e;
          margin: 0 0 8px 0;
          letter-spacing: -0.5px;
        }

        .login-subtitle {
          font-size: 15px;
          color: #666;
          margin: 0;
        }

        .login-form {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .input-group {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .input-group label {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          letter-spacing: 0.3px;
        }

        .input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }

        .input-icon {
          position: absolute;
          left: 14px;
          color: #999;
          pointer-events: none;
        }

        .input-wrapper input {
          width: 100%;
          padding: 12px 12px 12px 44px;
          border: 1.5px solid #e0e0e0;
          border-radius: 12px;
          font-size: 15px;
          transition: all 0.2s ease;
          outline: none;
          background: #fafafa;
        }

        .input-wrapper input:focus {
          border-color: #2c5364;
          background: white;
          box-shadow: 0 0 0 4px rgba(44, 83, 100, 0.1);
        }

        .input-wrapper input.error {
          border-color: #e53e3e;
          background: #fff5f5;
        }

        .error-message {
          font-size: 12px;
          color: #e53e3e;
          margin-top: 4px;
        }

        .login-button {
          background: linear-gradient(145deg, #0f2027 0%, #203a43 50%, #2c5364 100%);
          color: white;
          border: none;
          padding: 14px 20px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-top: 8px;
        }

        .login-button:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px -8px rgba(32, 58, 67, 0.5);
        }

        .login-button:active:not(:disabled) {
          transform: translateY(0);
        }

        .login-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .button-spinner {
          display: inline-block;
          vertical-align: middle;
        }

        .signup-link {
          text-align: center;
          font-size: 14px;
          color: #666;
          margin-top: 16px;
        }

        .signup-link a {
          color: #2c5364;
          text-decoration: none;
          font-weight: 600;
        }

        .signup-link a:hover {
          text-decoration: underline;
        }

        @media (max-width: 480px) {
          .login-card {
            padding: 32px 24px;
          }
          
          .login-title {
            font-size: 24px;
          }
        }
      `}</style>
    </div>
  );
}

export default Login;